<template>
  <div>
    <mensajeSistema></mensajeSistema>

    <v-tabs
      v-model="tab"
      dark
      class="rounded-lg"
      dense
      background-color="primary"
      active-class="tab-active"
      slider-color="#ffbc00"
    >
      <v-tab class="font-weight-black">Comunicado</v-tab>
      <v-tab class="font-weight-black">Efemérides</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <comunicado />
      </v-tab-item>
      <v-tab-item>
        <efemerides />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
//const luckyNumber = require('./luckyNumber')
// import Autentificacion from "../functions/autentificacion";
// import Validacion from "../functions/autentificacion";
import { mapMutations, mapGetters, mapActions } from "vuex";

import Comunicado from "@/views/Inicio/Inicio/components/Comunicados.vue";
import Efemerides from "@/views/Inicio/Inicio/components/Efemerides.vue";

export default {
  name: "home",

  components: {
    comunicado: Comunicado,
    efemerides: Efemerides,
  },

  data() {
    return {
      mensaje: { tipo: "S", mensaje: "hi", tiempo: null }, // mensaje de sistema
      tab: 0,
      datoLogin: sessionStorage, // sesion del sistema
      paramComponente: { id_modulo: 4, id_submodulo: 2 },
      prueba: null,
    };
  },

  mounted() {
    //console.log("saludar")
    //Autentificacion.saludo()
    // alert(Autentificacion.rul)
    //console.log(validacion.rul)
  },

  created() {
    this.setTituloMenu("INICIO");
    this.actualizarParamentro();
    //this.prueba = "hola wuilmer"
    this.prueba = this.$i18n.t("titulo.salon");
  },

  methods: {
    ...mapMutations(["setTituloMenu"]),

    ...mapActions("login", ["parametroComponente"]),
    ...mapMutations("mensajeSis", ["setEnviar"]),

    enviarMensaje() {
      //this.setEnviar(this.mensaje);
    },

    actualizarParamentro() {
      //  alert(JSON.stringify(process.env));
      //console.log( `parametroComponente ${JSON.stringify(this.paramComponente)}`)
      //alert(this.URL_FRONDEND)
      this.enviarMensaje();
      this.parametroComponente(this.paramComponente);
    },
  },

  computed: {
    // a computed getter
    ...mapGetters("login", ["componenteEvento"]),
  },
};
</script>

<style scoped>
#fondo {
  margin: 0;
  height: 1000px;
  background-image: url("../assets/imagenes_home/home.png");
  /* The image used */
  background-color: #cccccc;
  /* Used if the image is unavailable */
  background-position: center;
  /* Center the image */
  background-repeat: no-repeat;
  /* Do not repeat the image */
  background-size: contain;
  /* Resize the background image to cover the entire container */
}

#fondo2 {
  margin: 0;
  height: 720px;
  background-color: #cccccc;
  /* Used if the image is unavailable */
  background-position: center;
  /* Center the image */
  background-repeat: no-repeat;
  /* Do not repeat the image */
  background-size: contain;
  /* Resize the background image to cover the entire container */
}

.margin_img {
  margin: auto;
}
    #fondo {
        margin: 0;
        height: 1000px;
        background-image: url("../assets/imagenes_home/home.png"); /* The image used */
        background-color: #cccccc; /* Used if the image is unavailable */
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: contain; /* Resize the background image to cover the entire container */
    }

    #fondo2 {
        margin: 0;
        height: 720px;
        background-color: #cccccc; /* Used if the image is unavailable */
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: contain; /* Resize the background image to cover the entire container */
    }

    .margin_img {
        margin: auto;
    }
</style>
